import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../_helpers/components/Button";

const Badgeuse = () => {
    const navigate = useNavigate();
    const [badgeuse, setBadgeuse] = useState(null);
    const loadBadgeuse = () => {
        setBadgeuse({ test: "" });
    };

    useEffect(() => {
        loadBadgeuse();
    }, []);

    return (
        <div className="flex justify-between">
            <Button
                action={() => {
                    navigate(-1);
                }}
                name={"< Liste des badgeuses"}
                type={"empty"}
            />
            <Button
                action={() => {
                    navigate(-1);
                }}
                name={"Editer"}
            />
        </div>
    );
};

export default Badgeuse;
